import { CARDANO_ADA_ASSET_ID } from "@sundae/cardano-utils";
import { Asset } from "../gql/generated/stats2.sdk";
import { ECardanoExplorer, ECardanoExplorerType } from "../stores";

export const ADA_METADATA: Asset = {
  poolId: "",
  slotAdded: 0,
  policyId: "",
  assetName: "Cardano",
  ticker: "ADA",
  assetId: CARDANO_ADA_ASSET_ID,
  decimals: 6,
  dateListed: null, // listed on DEX or minted?
  logo: "/static/images/cardano.png",
};

export const SUNDAE_METADATA: Asset = {
  assetId: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77.53554e444145",
  assetName: "SUNDAE",
  dateListed: "2023-05-02 23:54:11.886488711 +0000 UTC",
  decimals: 6,
  logo: "https://cdn.sundaeswap.finance/logos/983/9830390119461449821.png",
  policyId: "9a9693a9a37912a5097918f97918d15240c92ab729a0b7c4aa144d77",
  poolId: "0029cb7c88c7567b63d1a512c0ed626aa169688ec980730c0473b913.702008",
  priceToday: "0.0186358653",
  priceYesterday: "0.01802171402",
  slotAdded: 51075469,
  ticker: "SUNDAE",
  totalSupply: "2000000000",
};

export const DEFAULT_DECIMALS = 0;

export const CARDANO_EXPLORER_LINK_MAP = {
  [ECardanoExplorerType.policy]: {
    [ECardanoExplorer.cardanoscan]: "tokenPolicy",
    [ECardanoExplorer.cexplorer]: "policy",
  },
  [ECardanoExplorerType.transaction]: {
    [ECardanoExplorer.cardanoscan]: "transaction",
    [ECardanoExplorer.cexplorer]: "tx",
  },
};

export const readableAdaAssetId = `${ADA_METADATA.assetName}.${ADA_METADATA.ticker}`.toLowerCase();
